import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/trade-network-search.svg'
import _imports_1 from '../../../assets/icons/pad-pen.svg'
import _imports_2 from '../../../assets/icons/calu-pen.svg'
import _imports_3 from '../../../assets/icons/note-pen.svg'


const _withScopeId = n => (_pushScopeId("data-v-905bdb94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-log-sidenav" }
const _hoisted_2 = { class: "project-log-sidenav__header" }
const _hoisted_3 = { class: "project-log-sidenav__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Project "),
  /*#__PURE__*/_createElementVNode("strong", null, " Logs")
], -1))
const _hoisted_5 = { class: "audit__logs" }
const _hoisted_6 = { class: "confirm_date" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = { class: "overview__detail__wrapper" }
const _hoisted_10 = { class: "overview__detail__date" }
const _hoisted_11 = { class: "overview__detail__item__wrapper" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_15 = { class: "overview__detail__content" }
const _hoisted_16 = { class: "overview__detail__text" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "overview__detail__time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", {
      class: _normalizeClass(["project-log-sidenav__side tw-right-[-535px]", { 'tw-right-[0]': $props.isOpen }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_v_icon, {
            icon: "mdi-close",
            onClick: $setup.onClose,
            class: "tw-cursor-pointer"
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_DatePicker, {
              modelValue: $setup.dataRange,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dataRange) = $event)),
              modelModifiers: { range: true },
              popover: true
            }, {
              default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
                _createElementVNode("div", {
                  class: "calendar__select",
                  onClick: () => togglePopover()
                }, [
                  _createVNode(_component_v_text_field, _mergeProps({
                    value: 
                      inputValue.start
                        ? `${inputValue.start}
            ${inputValue.end}`
                        : ''
                    ,
                    variant: "outlined"
                  }, _toHandlers(inputEvents), {
                    placeholder: "Choose Date",
                    class: "date__start c-input",
                    "prepend-icon": "mdi-calendar-text",
                    color: "#0C0F4A"
                  }), null, 16, ["value"])
                ], 8, _hoisted_7)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_btn, {
              "prepend-icon": "mdi-tray-arrow-down",
              class: "button button-lightGray",
              size: "large",
              onClick: $setup.downloadAuditLogs
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Download XLS ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_v_text_field, {
            modelValue: $setup.searchLogs,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchLogs) = $event)),
            placeholder: "Search",
            class: "search_field",
            "bg-color": "#fff",
            variant: "outlined"
          }, {
            "prepend-inner": _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.auditLogsList, (group, date) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "overview__detail",
                key: date
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h6", null, _toDisplayString(date), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (log, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "overview__detail__item",
                      key: i
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(`overview__detail__icon overview__detail__icon__${log?.category}`)
                      }, [
                        (log?.category == 'project')
                          ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            }))
                          : (log?.category == 'trade-passport')
                            ? (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_icon, { key: 2 }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              }))
                      ], 2),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("p", {
                            innerHTML: log?.content
                          }, null, 8, _hoisted_17)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("p", null, _toDisplayString(log?.time) + " IST", 1),
                          _createVNode(_component_v_icon, {
                            color: "#FAA500",
                            onClick: ($event: any) => (
                          $setup.onRenderToLogModule(log?.category, log?.meta?.id)
                        ),
                            icon: "mdi-chevron-right-circle"
                          }, null, 8, ["onClick"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ], 2),
    _createElementVNode("section", {
      class: _normalizeClass(["project-log-sidenav__overlay tw-hidden", { '!tw-flex': $props.isOpen }])
    }, null, 2)
  ]))
}